module.exports = __webpack_public_path__ + "static/stepsBanner-9de5fdcbae655ea39131cfe8797c05be.png";